import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import PubSub from "pubsub-js";

import { withRouter } from "react-router-dom";
import { map } from "lodash";
import {
  Layout,
  Menu,
  Dropdown,
  Spin,
  Select,
  Button,
  Popover,
  Input,
  Modal,
  message,
  Tooltip,
} from "antd";
import {
  CopyOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import RouterList from "./routerList";
import Language from "@/components/Common/Language";
import {
  login,
  logout,
  getUserInfo,
  getEnvCheck,
  getInfo,
  updateInfo,
} from "@/actions/auth";
import { Cookie } from "@/utils/cookie";
import Login from "../Login/Login";
import Register from "../Register/Register";
import Password from "../Password/Password";
import MobileInvite from "../MobileInvite/MobileInvite";
import copyBatch from "@/utils/copy";
import XunfeiAi from "../XunfeiAi";
import logo from "@/assets/image/logo.png";
import home1 from "@/assets/image/home1.png";
import home2 from "@/assets/image/home2.png";
import warnPng from "@/assets/image/warn.png";
import successPng from "@/assets/image/success.png";
import leftlogo from "@/assets/image/leftlogo.png";
import logImg from "@/assets/image/logImg1.png";
import vip from "@/assets/image/vip.png";
import shopIcon from "@/assets/image/shopIcon.png";
import header1 from "@/assets/image/header1.png";
import header2 from "@/assets/image/header2.png";
import header3 from "@/assets/image/header3.png";
import ercode from "@/assets/image/ercode.png";

import LogContainer from "../../components/Supplier/LogContainer";
import { selectShop } from "@/api/shop";

import styles from "./index.module.scss";

import "./index.scss";
import intl from "react-intl-universal";

const { Header, Content, Footer, Sider } = Layout;

const { pathname } = window.location;

const { Option } = Select;
const MenuLayout = ($$) => {
  // 左侧菜单相关参数
  const [collapsed, setCollapsed] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [contentLeftMargin, setContentLeftMargin] = useState(200);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [defaultOpenKeys, setDefaultOpenKeys] = useState([
    "1",
    "3",
    "6",
    "7",
    "10",
    "15",
    "20",
    "30",
  ]);
  const [selecObj, setSelecObj] = useState<any>("");
  const [showShopList, setShowShopList] = useState(false);

  const [selectShopInfo, setSelectShopInfo] = useState<any>({});
  const [showChangeModal, setShowChangeModal] = useState(false);

  // 新增：用于存储 shopList 的引用
  const shopListRef = useRef(null);

  useEffect(() => {
    const data = sessionStorage.getItem("firstModal");
    if (!data) {
      // setIsModalVisible(true);
      sessionStorage.setItem("firstModal", "1");
    }
  }, []);

  // 新增：监听全局点击事件，判断是否点击在 shopList 外部
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (shopListRef.current && !shopListRef.current.contains(event.target)) {
        setShowShopList(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // set selectedKeys and defaultOpenKeys 根据path获取高亮和展开的节点
  const setSelectedNodeInfo = (menuList) => {
    if (menuList && menuList.length > 0) {
      menuList.forEach((item) => {
        if (item.path === pathname && item.type === 1) {
          setSelecObj(item);
          // 防止之前是页面菜单修改成分组菜单后的path脏数据
          setSelectedKeys([`${item.id}`]);
          // setDefaultOpenKeys(item.parentIdList || []);
          return;
        }
        if (pathname.includes(item.path) && item.type === 1) {
          setSelectedKeys([`${item.id}`]);
          // setDefaultOpenKeys(item.parentIdList || []);
          return;
        }
        setSelectedNodeInfo(item.children);
      });
    }
  };

  const toggleSideBar = () => {
    setCollapsed(!collapsed);
    setContentLeftMargin(collapsed ? 262 : 0);
  };

  const pageCompontent = {
    "/login": <Login />,
    "/register": <Register />,
    "/password": <Password />,
    "/mobileInvite": <MobileInvite />,
  };

  // mounted
  useEffect(() => {
    if (Cookie.get("token") && !pageCompontent[pathname]) {
      $$.getUserInfo();
      $$.getEnvCheck();
    } else if (!pageCompontent[pathname]) {
      window.location.href = "/login";
    } else {
      // do
    }
  }, []);

  // listen menuList data
  useEffect(() => {
    if (pathname === "/envconfig") {
      setSelecObj({ title: intl.get("menuLayout_title") });
      setSelectedKeys([`envconfig`]);
      return;
    }
    if ($$.menuList.length > 0) {
      // set active node and open nodes
      setSelectedNodeInfo($$.menuList);
    }
  }, [$$.menuList]);

  useEffect(() => {
    PubSub.subscribe("TK_CHECK_ENV_RESULT", (_msg, data) => {
      if (data?.data.hasLogin) {
        $$.getEnvCheck();
      }
    });

    return () => {
      PubSub.unsubscribe("TK_CHECK_ENV_RESULT");
    };
  }, []);

  const onUserActionClick = (key) => {
    switch (key) {
      case "logout":
        $$.logout();
        break;
      case "invitation":
        setShowModal(true);
        break;
      default:
        break;
    }
  };

  const changeShop = async (id, name) => {
    const res = await selectShop({ id });
    if (res.code === 200) {
      message.success(`${intl.get("menuLayout_shop")}${name}`);
      $$.getInfo();
    }
  };

  const onMenuItemClick = (id, parentIdList, path, type, obj) => {
    // type - 菜单类型
    const { history } = $$;

    if (window.location.pathname === path) return;

    // 如果点击分组菜单-不跳转
    if (type === 3) return;
    setSelecObj(obj);
    history.push(path);

    setSelectedKeys([`${id}`]);
    setDefaultOpenKeys(parentIdList || []);

    // 解决内部跳转 点击菜单返回主页问题
    if (window.location.pathname.indexOf(path) === 0) {
      history.push("/");
      setTimeout(() => {
        history.replace(path);
      });
    }
  };

  const renderUserAction = () => {
    const { nickname, invitationCode } = $$;
    const items: MenuProps["items"] = [
      {
        key: "2",
        label: (
          <div onClick={() => onUserActionClick("invitation")}>
            {intl.get("menuLayout_invit")}
          </div>
        ),
      },
      {
        key: "1",
        label: (
          <div onClick={() => onUserActionClick("logout")}>
            {intl.get("menuLayout_logout")}
          </div>
        ),
      },
    ];

    return (
      <div className="user-view">
        {$$.currentMerchantShop?.shopId && (
          <div className={styles.shopViewBox}>
            <Select
              className={styles.keyOptionviewSelect}
              placeholder={intl.get("envConfig_selectShopOwner")}
              onChange={(e, data: any) => {
                if (e === $$.currentMerchantShop?.id) {
                  return;
                }

                setSelectShopInfo({
                  id: e,
                  name: `${data.children.join(" ")}`,
                });
                setShowChangeModal(true);
              }}
              value={$$.currentMerchantShop?.id}
              labelRender={(propValue) => {
                const item = $$?.shopList.find((item) => {
                  return item.id === propValue.value;
                });
                return (
                  <div className={styles.selectLableView}>
                    <span
                      className={styles.countryName}
                      style={{ marginRight: "6px" }}
                    >
                      <img src={shopIcon} alt="" />
                      {item?.countryName}
                    </span>

                    {item?.shopName}
                  </div>
                );
              }}
            >
              {$$?.shopList.map((item) => {
                return (
                  <Option key={item.id} value={item.id}>
                    {item.countryName} - {item.shopName}
                  </Option>
                );
              })}
            </Select>
          </div>
        )}

        <div
          className={styles.inviteView}
          onClick={() => {
            onUserActionClick("invitation");
          }}
        >
          {intl.get("menuLayout_invite")}
          <span>{intl.get("menuLayout_rebate")}</span>
        </div>

        <div className={styles.headerIcon}>
          <Tooltip
            color={"#fff"}
            placement="top"
            title={
              <>
                <img style={{ width: 140 }} src={ercode} alt="" />
              </>
            }
            trigger="click"
          >
            <img src={header1} alt="" />
          </Tooltip>
        </div>
        <div
          className={styles.headerIcon}
          onClick={() => {
            window.open(
              "https://scnspbynpgwz.feishu.cn/wiki/NLHJwWpyqiif0jkTWO7cj7Xxnvg?from=from_copylink",
              "_blank"
            );
          }}
        >
          <img src={header2} alt="" />
        </div>
        <div className={styles.headerIcon}>
          <Language dom={<img src={header3} alt="" />} />
        </div>

        <Dropdown
          menu={{
            items: [
              ($$.isTryout === 1 || $$.isWhiteList === 1) && $$.endTime
                ? {
                    key: "3",
                    label: (
                      <div style={{ color: "red" }}>
                        {intl.get("menuLayout_end")}
                        {$$.endTime}
                      </div>
                    ),
                  }
                : null,
              ...items,
            ],
          }}
          trigger={["click"]}
        >
          <span className="user-action">
            <img src={logo} alt="" />
            <span>{nickname || "***"} </span>
            <span>{`(${$$.email})`}</span>
          </span>
        </Dropdown>
      </div>
    );
  };

  const renderMenuList = (menuList) => {
    return map(menuList, (m) => {
      if (m.subMenu.length === 0) {
        return (
          <Menu.Item
            key={m.id}
            onClick={() =>
              onMenuItemClick(m.id, m.parentIdList, m.path, m.type, m)
            }
          >
            {m.selectedIcon && m.unselectedIcon ? (
              <div className="anticon menu-icon">
                <div className="menu-img">
                  <img
                    src={
                      selectedKeys.indexOf(String(m.id)) === -1
                        ? m.unselectedIcon
                        : m.selectedIcon
                    }
                    alt=""
                  />
                </div>
              </div>
            ) : null}
            <span>{m.title}</span>
          </Menu.Item>
        );
      }

      return (
        <Menu.SubMenu
          key={m.id}
          title={
            <span>
              {(m.icon || m.selectedIcon || m.unselectedIcon) && !m.parentId ? (
                <div className="anticon menu-icon">
                  <div className="menu-img">
                    <img
                      src={m.unselectedIcon ? m.unselectedIcon : m.selectedIcon}
                      alt=""
                    />
                    <img
                      src={m.selectedIcon ? m.selectedIcon : m.unselectedIcon}
                      alt=""
                    />
                  </div>
                </div>
              ) : null}
              <span style={{ color: "#7b8495", fontSize: "14px" }}>
                {m.title}
              </span>
            </span>
          }
        >
          {renderMenuList(m.subMenu)}
        </Menu.SubMenu>
      );
    });
  };

  const { menuList, location, systemLoading } = $$;

  if (systemLoading && pathname !== "/login") {
    return (
      <div className="system-loading-wrapper">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      {pageCompontent[pathname] ? (
        pageCompontent[pathname]
      ) : (
        <Layout
          className={`menu-layout ${
            location.pathname.split("/").length > 0
              ? location.pathname.split("/")[1]
              : ""
          } ${styles.homeContent}`}
        >
          <Sider
            className="sidebar"
            trigger={null}
            collapsible
            collapsed={collapsed}
            width={200}
            collapsedWidth={0}
          >
            <div className="logo-wrapper">
              <img src={leftlogo} alt="" />
            </div>

            <div className="env-box">
              {$$.email && $$.email !== "tianer666@icloud.com" && (
                <div
                  className={`env-menu ${
                    selectedKeys.indexOf("envconfig") !== -1 &&
                    "env-menu-select"
                  }`}
                  onClick={() => {
                    setSelecObj({ title: intl.get("menuLayout_title") });
                    setSelectedKeys([`envconfig`]);
                    $$.history.push("/envconfig");
                  }}
                >
                  <img
                    src={
                      selectedKeys.indexOf("envconfig") !== -1 ? home2 : home1
                    }
                    alt=""
                  />
                  <div>
                    {intl.get("menuLayout_title")}
                    {$$.applicationInstalled &&
                    $$.tiktokMerchantLoginStatus === 2 ? (
                      <span className="success">
                        <img src={successPng} alt="" />
                      </span>
                    ) : (
                      <span className="warn">
                        <img src={warnPng} alt="" />
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>
            <Menu
              // theme="dark"
              style={{ height: "calc(100% - 130px)", overflowY: "auto" }}
              mode="inline"
              defaultOpenKeys={defaultOpenKeys}
              selectedKeys={selectedKeys}
            >
              {renderMenuList(menuList)}
            </Menu>
          </Sider>

          <Layout
            className="right-section"
            style={{ marginLeft: contentLeftMargin }}
          >
            <Header className="header">
              <div className="headerLeft">
                <div onClick={toggleSideBar}>
                  {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                </div>

                <span className="title">{selecObj.title || selecObj.name}</span>
              </div>

              {renderUserAction()}
            </Header>

            <Content
              className={`npm-package-content ${
                $$.logShow && "npm-package-content-show"
              }`}
            >
              <div
                className={`${styles.leftContainer} ${
                  $$.logShow && styles.leftContainerShow
                }`}
              >
                <RouterList
                  userId={$$.id}
                  userName={$$.userName}
                  length={$$.menuList.length}
                  menuList={$$.menuList}
                  history={$$.history}
                />
              </div>

              <div
                className={`${styles.logContainer} ${
                  $$.logShow && styles.logContainerShow
                }`}
              >
                <div className={styles.title}>
                  {intl.get("menuLayout_systemLog")}
                  <span
                    onClick={() => {
                      $$.updateInfo({
                        logShow: false,
                      });
                    }}
                  >
                    {intl.get("menuLayout_sq")}
                  </span>
                </div>
                {$$.id && (
                  <div className={styles.logContent}>
                    <LogContainer />
                  </div>
                )}
              </div>
              <Tooltip
                color={"#fff"}
                placement="left"
                title={
                  <>
                    <img style={{ width: 200 }} src={ercode} alt="" />
                    <p
                      style={{
                        color: "rgba(0, 0, 0,0.45)",
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                    >
                      {intl.get("menuLayout_vipText")}
                    </p>
                  </>
                }
                trigger="click"
              >
                <div className={styles.logVipView}>
                  <img src={vip} alt="" />
                  {intl.get("menuLayout_vip")}
                </div>
              </Tooltip>

              {!$$.logShow && (
                <div
                  className={styles.logTipView}
                  onClick={() => {
                    $$.updateInfo({
                      logShow: true,
                    });
                  }}
                >
                  <img src={logImg} alt="" />
                  {intl.get("menuLayout_taskLog")}
                </div>
              )}
              {/* <XunfeiAi userId={$$.id} userName={$$.userName} /> */}
            </Content>

            {/* <Footer className="footer">
              Copyright ©{new Date().getFullYear()} 95AI管理系统
            </Footer> */}
          </Layout>
          <Modal
            centered
            open={showModal}
            width={400}
            onCancel={() => setShowModal(false)}
            onOk={() => setShowModal(false)}
          >
            <>
              {intl.get("menuLayout_invite_tip")}
              <br />
              {intl.get("menuLayout_invite_tip1")}
              <br />
              <Input
                readOnly
                allowClear
                value={`${window.location.origin}/register?code=${$$.invitationCode}`}
                suffix={
                  <>
                    <CopyOutlined
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        copyBatch(
                          `${window.location.origin}/register?code=${$$.invitationCode}`
                        );
                      }}
                    />
                  </>
                }
              />
            </>
          </Modal>
          <Modal
            // title="达人评分高级配置"
            open={isModalVisible}
            centered
            onCancel={() => {
              setIsModalVisible(false);
            }}
            footer={null}
            width={800}
          >
            <div className={styles.modalContent}>
              <div className={styles.title}>
                {intl.get("index_modal_title")}
              </div>
              <p className={styles.desc}>{intl.get("index_modal_desc")}</p>
              <div className={styles.tip}>{intl.get("index_modal_desc1")}</div>
              <ul>
                <li>{intl.get("index_modal_desc2")}</li>
                <li>{intl.get("index_modal_desc3")}</li>
                <li>{intl.get("index_modal_desc4")}</li>
              </ul>
              <p className={styles.tip}>{intl.get("index_modal_desc5")}</p>
              <p className={styles.tip}>{intl.get("index_modal_desc6")}</p>
            </div>
          </Modal>

          <Modal
            title={intl.get("common_http_title")}
            width={700}
            open={showChangeModal}
            onCancel={() => {
              setShowChangeModal(false);
            }}
            destroyOnClose
            centered
            afterClose={() => {
              setSelectShopInfo({});
            }}
            onOk={() => {
              changeShop(selectShopInfo.id, selectShopInfo.name);
            }}
          >
            <div>{intl.get("homePage_change_content")}</div>
          </Modal>
        </Layout>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const {
    nickname,
    id,
    menuList,
    systemLoading,
    invitationCode,
    applicationInstalled,
    tiktokMerchantLoginStatus,
    email,
    currentMerchantShop,
    shopList,
    logShow,
    isTryout,
    isWhiteList,
    endTime,
  } = state.auth;
  return {
    nickname,
    id,
    menuList,
    systemLoading,
    invitationCode,
    applicationInstalled,
    tiktokMerchantLoginStatus,
    email,
    currentMerchantShop,
    shopList,
    logShow,
    isTryout,
    isWhiteList,
    endTime,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    login,
    logout,
    getUserInfo,
    getEnvCheck,
    getInfo,
    updateInfo,
  })(MenuLayout)
);
